<template>
  <div class="page-toast">
    <router-link class="page-back" to="/m/demo/home">
      <i class="mintui mintui-back"></i>
    </router-link>
    <h1 class="page-title">Toast</h1>
    <div class="page-toast-wrapper">
      <mt-button @click.native="openToast" size="large">点击弹出 Toast</mt-button>
      <mt-button @click.native="openToastWithIcon" size="large">点击弹出带有 icon 的 Toast</mt-button>
      <mt-button @click.native="openBottomToast" size="large">自定义 Toast 位置</mt-button>
    </div>
  </div>
</template>

<style>
.page-toast-wrapper {
  padding: 0 20px;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
}

.page-toast-wrapper button:not(:last-child) {
  margin-bottom: 20px;
}
</style>

<style>
html,
body {
  background-color: #fafafa;
  -webkit-overflow-scrolling: touch;
  user-select: none;
}

a {
  color: inherit;
}

.page-back {
  display: block;
  width: 40px;
  height: 40px;
  text-align: left;
  color: black;
  text-decoration: none;
}

.page-back i {
  font-size: 24px;
  line-height: 40px;
}
</style>

<script>
import { Toast } from "mint-ui";

export default {
  methods: {
    openToast() {
      Toast("提示信息");
    },
    openToastWithIcon() {
      Toast({
        message: "操作成功",
        iconClass: "mintui mintui-success"
      });
    },
    openBottomToast() {
      Toast({
        message: "提示信息",
        position: "bottom"
      });
    }
  },
  controller: "UI",
  action: "Toast"
};
</script>
